import { z as i } from "../index-C56U8D_Y.js";
const _ = i.string().min(1), e = i.object({
  additives: _,
  alcohol_acidities: _,
  alcohol_acidity_per_gram: _,
  alcohol_age: _,
  alcohol_age_unit: _,
  alcohol_bodies: _,
  alcohol_color: _,
  alcohol_degree_of_wort: _,
  alcohol_percentage: _,
  alcohol_subregion: _,
  alcohol_sugar_content: _,
  alcohol_sweetness_level: _,
  alcohol_tannins: _,
  alcohol_type: _,
  alcohol_vintage: _,
  alcohol_vintner: _,
  allergens: _,
  allergens_disclaimer: _,
  attributes: _,
  breadcrumb: _,
  brand_name: _,
  client_outreach_check_prices: _,
  client_outreach_onboarding: _,
  client_outreach_question: _,
  client_outreach_url_text: _,
  country_of_origin: _,
  descriptive_size: _,
  diets: _,
  dry_matter: _,
  fat_in_milk: _,
  file: _,
  files: _,
  fishing_catch_area: _,
  fishing_catch_country: _,
  fishing_catch_method: _,
  fishing_info: _,
  fishing_name: _,
  fishing_prod_method: _,
  fishing_scientific_name: _,
  fishing_storage_states: _,
  fish_meat_poultries: _,
  hide: _,
  ingredients: _,
  instructions_usage: _,
  instructions_preparation: _,
  instructions_serving: _,
  instructions_product_yield: _,
  instructions_storage: _,
  instructions_opened_life_span: _,
  instructions_production_life_span: _,
  instructions_compulsory_additives: _,
  juice_content: _,
  licensee_registrar: _,
  loading: _,
  manufacturer: _,
  measurements: _,
  not_found: _,
  nut_table_nutritional_content: _,
  nut_table_nutritional_content_unprepared: _,
  nutritional_claims: _,
  nutritional_content: _,
  produced_for: _,
  consumer_support: _,
  product_activities: _,
  product_batches: _,
  product_carousel_first: _,
  product_carousel_next: _,
  product_carousel_prev: _,
  product_carousel_last: _,
  product_info: _,
  recommended_products: _,
  responsibility_carbon_footprint: _,
  responsibility_palm_oil: _,
  responsibility_soy: _,
  responsibility_water_footprint: _,
  responsibility_water_footprint_unit: _,
  responsibility_cbam_product_code: _,
  responsibility_cbam_product_code_unit_true: _,
  responsibility_cbam_product_code_unit_false: _,
  responsibility_animal_welfare_title: _,
  responsibility_animal_welfare_content: _,
  safety_info: _,
  show_everything: _,
  use_and_storage: _,
  packaging_markings: _,
  warranties: _,
  certifications: _,
  organic_certifications: _,
  product_ingredient_details: _,
  show_more_batches: _,
  materials: _,
  "5FTHF": _,
  AATN: _,
  ASH: _,
  BIOT: _,
  CA: _,
  CARTB: _,
  CAFFN: _,
  "CHOL-": _,
  CHOLC: _,
  CHOAVL: _,
  CLD: _,
  CR: _,
  COLG: _,
  CU: _,
  CHOLE: _,
  "ENER-": _,
  ENERKJO: _,
  FAMSCIS: _,
  FAPUCIS: _,
  FAPUN3F: _,
  FAPUN6F: _,
  FASAT: _,
  FAT: _,
  FD: _,
  FE: _,
  FIBTG: _,
  FOL: _,
  FOLDFE: _,
  FRUS: _,
  G_NICT: _,
  GLUCNB: _,
  GINSENG: _,
  HMB: _,
  ID: _,
  K: _,
  LACS: _,
  L_CARNITINE: _,
  MG: _,
  MO: _,
  MN: _,
  NA: _,
  NACL: _,
  NIA: _,
  NUCLEOTIDE: _,
  OLSAC: _,
  P: _,
  PANTAC: _,
  POLYL: _,
  "PRO-": _,
  RIBF: _,
  SALTEQ: _,
  SE: _,
  STARCH: _,
  SUGAR: _,
  "SUGAR-": _,
  TAU: _,
  THIA: _,
  UNSPECIFIED: _,
  "VITA-": _,
  VITB12: _,
  "VITB6-": _,
  VITC: _,
  "VITC-": _,
  VITD: _,
  "VITD-": _,
  VITE: _,
  "VITE-": _,
  VITK: _,
  X_FATRSA: _,
  X_MELA: _,
  ZN: _,
  WATER: _,
  "CONTAINS-NUTS": _,
  "FREE_FROM-ADDITIVES": _,
  "FREE_FROM-ALCOHOL": _,
  "FREE_FROM-ANTIBIOTICS": _,
  "FREE_FROM-AZO_DYE": _,
  "FREE_FROM-CAFFEINE": _,
  "FREE_FROM-COLOURING_AGENTS": _,
  "FREE_FROM-EGGS": _,
  "FREE_FROM-ENERGY": _,
  "FREE_FROM-FAT": _,
  "FREE_FROM-GELATINE": _,
  "FREE_FROM-GLUTEN": _,
  "FREE_FROM-LACTOSE": _,
  "FREE_FROM-MILK": _,
  "FREE_FROM-NUTS": _,
  "FREE_FROM-PORK_GELATINE": _,
  "FREE_FROM-BEEF_GELATINE": _,
  "FREE_FROM-PRESERVATIVES": _,
  "FREE_FROM-SODIUM_SALT": _,
  "FREE_FROM-SUGARS": _,
  "FREE_FROM-YEAST": _,
  "HIGH-FIBRE": _,
  "HIGH-SODIUM_SALT": _,
  "LOW-FAT": _,
  "LOW-LACTOSE": _,
  "LOW-SATURATED_FAT": _,
  "LOW-SODIUM_SALT": _,
  "LOW-SUGARS": _,
  "NO_ADDED-SUGARS": _,
  GOODS_FROM_FINLAND_BLUE_SWAN: _,
  FINNISH_HEART_SYMBOL: _,
  VEGAN: _,
  MADE_IN_FINLAND_FLAG_WITH_KEY: _,
  EU_ORGANIC_FARMING: _,
  EU_ECO_LABEL: _,
  FAIR_TRADE_MARK: _,
  RAINFOREST_ALLIANCE: _,
  RAINFOREST_ALLIANCE_PEOPLE_NATURE: _,
  RAINFOREST_ALLIANCE_INFO: _,
  RAINFOREST_ALLIANCE_ICON: _,
  PUHTAASTI_KOTIMAINEN: _,
  SVANEN: _,
  close: _,
  SAFETY_DATA_SHEET: _,
  FOOD_CONTACT_CONFORMITY_CERTIFICATE: _,
  IFU: _
}), t = e.keyof(), n = t.options, s = t.enum;
function a(o) {
  return n.includes(
    o
  );
}
export {
  t as LocalizationSchemaKeys,
  s as LocalizationSchemaKeysEnum,
  n as LocalizationSchemaKeysOptions,
  a as isLocalizationSchemaKey,
  e as localeSchema
};
